import { DownloadIcon } from "@radix-ui/react-icons";
import { Button } from "@radix-ui/themes";
import toast from "react-hot-toast";

const CopyCSVToClipboard = ({
  value,
  disabled = false,
}: {
  value: string;
  disabled?: boolean;
}) => {
  const handleCopy = () => {
    navigator.clipboard
      .writeText(value)
      .then(() => {
        toast.success("Copied to clipboard");
      })
      .catch((error) => {
        console.error("Failed to copy to clipboard:", error);
      });
  };

  return (
    <Button
      radius="full"
      size="1"
      variant="outline"
      onClick={handleCopy}
      disabled={disabled}
    >
      <DownloadIcon />
      Copy as CSV to clipboard
    </Button>
  );
};

export default CopyCSVToClipboard;
